<app-page-section>
  <div class="text-center mb-4">
    <p class="text-uppercase text-primary fw-semibold small mb-2">Error {{ code }}</p>
    <h1 class="display-5 fw-bold">{{ title }}</h1>
    <p class="lead text-muted">{{ description }}</p>
  </div>
  <div class="error-card text-center mx-auto">
    <div class="display-1 fw-bold text-primary">{{ code }}</div>
    <p class="text-muted mb-4">{{ description }}</p>
    <a class="btn btn-primary" routerLink="/">Back home</a>
  </div>
</app-page-section>